<script setup lang="ts">
import { computed } from 'vue';
import { getIconSvgUrl, type IconName } from '@workbench/core';
import { iconSizeMap, type IconSize } from './constants';

const { name, size = 'L' } = defineProps<{
  name: IconName;
  flipRtl?: boolean;
  size?: IconSize;
}>();

const style = computed(() => ({
  '--mask': `url(${getIconSvgUrl(name)})`,
  '--_size': iconSizeMap[size],
}));

/// template keeps the `name`, even tho it's not necessary, it's used by some workbench components CSS
/// we also add the wb-icon class name as the workbench components so it works inside other workbench components that expect the wb-icon class
</script>

<template>
  <div
    class="owpi-icon wb-icon"
    :name="name"
    :class="{ flipRtl }"
    :style
    aria-hidden="true"
  ></div>
</template>

<style lang="scss">
.owpi-icon {
  /** @prop --size: the width and height of the icon */
  --size: var(--_size);
  mask: var(--mask);

  // The icon is a mask, the color is set by the parent element
  background-color: currentColor;

  display: inline-block;
  vertical-align: middle;
  width: var(--size);
  height: var(--size);
  user-select: none;
  margin-block-start: 0 !important;
}

[dir='rtl'] .owpi-icon.flipRtl {
  transform: scaleX(-1);
}
</style>
